import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Optional, ViewChild} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Compbaser} from "../compbaser";
import {DEFAULT_PROTOCOL, DEFAULT_SERVER, isNullOrUndefOrEmpty} from "../../common";
import {FontLoaderService, LocalStoreService, StoreSelectorsService} from "../../services";
import {actionSceneFontsPreviewed} from "../../store/actions/user.actions";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {faRectangleXmark} from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import _ from "lodash";

export interface IFontPreview {
    id: number;
    name: string;
    loaded: boolean;
    url: string;
    favorite: boolean;
}

export interface UserData {
    id: string;
    name: string;
}


@Component({
    selector: 'app-font-preview',
    templateUrl: './font-preview.component.html',
    styleUrls: ['./font-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FontPreviewComponent extends Compbaser implements OnInit, AfterViewInit {

    readonly faRectangleTimes = faRectangleXmark;
    m_fontScene: Array<IFontPreview> = [];
    totalFontsToPreview = 0;
    fontsPreviewed: Array<string> = [];
    httpRequests = [];
    isShowFavorite = false;
    allFontsDownloaded = false;
    favoriteFonts: Array<string> = [];
    displayedColumns = ['id', 'name', 'favorite'];
    dataSource: MatTableDataSource<IFontPreview>;
    selectedFont;
    fontFilter = '';

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    onSelectedFont = new EventEmitter();

    constructor(private translocoService: TranslocoService,
                @Optional() @Inject(MAT_DIALOG_DATA) data,
                private fontLoaderService: FontLoaderService,
                private localStoreService: LocalStoreService,
                public dialogRef: MatDialogRef<FontPreviewComponent>,
                public storeSelector: StoreSelectorsService,
                private cd: ChangeDetectorRef) {
        super();
        this.cod(
            this.storeSelector.listenFontsPreviewed().subscribe((v) => {
                this.fontsPreviewed = _.cloneDeep(v);
            })
        );
    }

    ngOnInit() {
        const fonts = _.cloneDeep(this.fontLoaderService.getFontLibraryUnmodified());
        this.totalFontsToPreview = _.size(fonts);
        const favorites = this.localStoreService.getStorageValConfig('favoriteFonts');
        if (isNullOrUndefOrEmpty(favorites)) {
            this.favoriteFonts = [];
        } else {
            this.favoriteFonts = favorites.split(',');
        }

        Object.keys(fonts).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())).forEach((font, b) => {
            const s = `${fonts[font][0]}`.split(',')[0];
            const u = font.replace(/[\s\[\]\-!•™&:.,()`'?]/g, '');
            let favorite = false;
            if (this.favoriteFonts.indexOf(font) > -1) {
                favorite = true;
            }
            const fontPreview: IFontPreview = {id: b, name: font, loaded: false, url: u, favorite};
            this.m_fontScene.push(fontPreview);
            if (b < 11) this.loadFont(fontPreview);

        });
        this.dataSource = new MatTableDataSource(this.m_fontScene);
    }

    loadFont(fontObject) {
        if (this.fontsPreviewed.length == this.totalFontsToPreview) {
            this.allFontsDownloaded = true;
        }
        if (this.fontsPreviewed.indexOf(fontObject.url) > -1)
            return;
        this.fontsPreviewed.push(fontObject.url);
        const url = `${DEFAULT_PROTOCOL}${DEFAULT_SERVER}/TTF/${fontObject.url}.ttf`;
        const request = new XMLHttpRequest();
        this.httpRequests.push(request);
        request.addEventListener('readystatechange', (e) => {
            if (request.readyState == 2 && request.status == 200) {
                // Download is being started
            } else if (request.readyState == 3) {
                // Download is under progress
            } else if (request.readyState == 4) {
                // Downloading has finished
                // request.response holds the binary data of the font
                // this.m_fontScene[fontObject.url].loaded = true;
                // console.log('loading ' + url);
                const junction_font = new FontFace(`${fontObject.name}`, `url(${url})`);
                junction_font.load().then((loaded_face) => {
                    document.fonts['add'](loaded_face);
                    document.body.style.fontFamily = `"${fontObject.name}"`;
                }).catch((error) => {
                    console.log('err loading font ' + url);
                });
            }
        });
        request.addEventListener('progress', (e) => {
            // const percent_complete = (e.loaded / e.total) * 100;
            // console.log(percent_complete);
        });
        request.responseType = 'arraybuffer';
        request.open('get', url);
        request.send();

        /** a more raw way of downloading fonts for reference **/
        // this.playerService = this.injector.get('playerService');
        // const promise: Promise<any> = this.playerService.caching['getUrl'](url);
        // promise.then((typeFace) => {
        //   console.log(typeFace);
        // });
        // const ff = new FontFace(`${fontName}`, `url(${url})`);
        // ff.load().then((loaded_face) => {
        //   document.fonts['add'](loaded_face);
        //   document.body.style.fontFamily = `${fontStyle}`;
        //   alert('loaded font');
        // }).catch((error) => {
        //   alert('problem loading font ' + fontName);
        // });
    }

    toggleShowFavorites(checked) {
        this.isShowFavorite = !this.isShowFavorite;
        if (this.isShowFavorite) {
            this.applyFilterFavorites();
        } else {
            this.dataSource.filter = null;
        }
    }

    onCaptureFontStyle(row) {
        const name = row.name;
        const element = document.getElementById(name) as HTMLElement;
        this.onCapture(element, name);
        return;
    }

    onCapture(element, name) {
        html2canvas(element).then((canvas) => {
            canvas.toBlob((blob) => {
                const link = document.createElement("a");
                link.download = `${name}.png`;
                link.href = URL.createObjectURL(blob);
                link.click();
                return;
            }, 'image/png');
        });
    }

    toggleFavorite(row) {
        this.dataSource.data.forEach((v: IFontPreview) => {
            if (v.name === row.name) {
                v.favorite = !v.favorite;
            }
        });
        const saveFavoriteFonts = [];
        this.dataSource.data.forEach((v: IFontPreview) => {
            if (v.favorite) {
                saveFavoriteFonts.push(v.name);
            }
        });
        if (saveFavoriteFonts.length > 0) {
            this.localStoreService.setStorageValConfig('favoriteFonts', saveFavoriteFonts.join());
        }
    }

    loadPage(i_page) {
        const pagedOutput = [];
        let itemIndex = 0;
        this.dataSource.data.forEach(element => {
            if ((itemIndex >= this.paginator.pageIndex * this.paginator.pageSize)
                && (itemIndex < (this.paginator.pageIndex + 1) * this.paginator.pageSize)) {
                pagedOutput.push(element);
                this.loadFont(element);
            }
            itemIndex++;
        });
    }

    onSelectedFontPreview(i_font) {
        this.selectedFont = i_font;
        this.onSelectedFont.emit(i_font);
    }

    cancelFontDownloads() {
        this.storeSelector.dispatch(actionSceneFontsPreviewed({fonts: this.fontsPreviewed}));
        this.httpRequests.forEach((v) => {
            v.abort();
        });
    }

    /**
     * Set the paginator and sort after the view init since this component will
     * be able to query its view for the initialized paginator and sort.
     */
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
        this.dataSource.filteredData.forEach((i_font) => {
            this.loadFont(i_font);
        });
    }

    clearSelection() {
        this.fontFilter = '';
        this.applyFilter('');
    }

    applyFilterFavorites() {
        this.dataSource.filterPredicate = (data: any, filter) => data.favorite;
        this.dataSource.filter = 'favorite';
        this.dataSource.filteredData.forEach((i_font) => {
            this.loadFont(i_font);
        });
    }

    onClose() {
        this.dialogRef.close();
        this.cancelFontDownloads();
    }
}

